import React, { useEffect, useState } from "react";
import { Warning, WarningCircle, X } from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import PageLoader from "../loader/PageLoader";
import { RejectHotel } from "./RejectAPI";
import { toast } from "react-toastify";
import PromoBreakdown from "./PromoBreakdown";

const RestaurantDining = ({ func, selectedRequest }) => {
  const [data, setData] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState(false);

  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [guestRequestId, setGuestRequestId] = useState("");
 
  const [selectedStaff, setSelectedStaff] = useState("");
  const [disabled, setDisabled] = useState(false);

  // Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/hotels/${selectedRequest.hotelId}/restaurant-food-request`,
          {
            params: {
              guest_request_id: selectedRequest.requestId,
            },
          }
        );

       

        setGuestRequestId(response.data?.guest_request_id);
        setData(response.data);
        
        setRemarks(response?.data?.remarks || "");
        if(response?.data?.room_number){
          setDisabled(true);
        }
        setSelectedStaff(String(response?.data?.room_number || "")); // ensure string
        setLoading(false);
      } catch (err) {
        setErrors({ fetch: "Failed to fetch web check-in data" });
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedRequest]);

  // Validation For Form
  const validateForm = () => {
    try {
      const newErrors = {};

      // Always convert to string before trimming
      if (!String(selectedStaff).trim()) {
        newErrors.selectedStaff = "Room is required";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Return true if no errors
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  // Respond Guest
  const handleRespondToGuest = async () => {
    try {
      // Validate form
      if (!validateForm()) return;

      const payload = {
        remarks: remarks,
        room_number: parseInt(selectedStaff,10) || "",
      };

      console.log("Payload : ", payload);
      // return; // remove this after testing

      await axiosInstance.put(
        `/api/v1/hotels/${selectedRequest.hotelId}/restaurant-food-request/${data.id}`,
        payload
      );

      toast.success("Restaurant Dining Updated Successfully");
      setDisabled(true);
      // func(false);
    } catch (err) {
      console.error(err);
      if(err?.response?.data?.message==="booked room not found for the given room number or does not belong to hotel"){
        setErrors({ selectedStaff: "Room does not belong to any booking" });
      }
      else{
        setErrors({ respond: err?.response?.data?.message || "Failed to respond to guest" });
      }
      // err?.response?.data?.message
    }
  };

  // Reject Guest
  const handleRejectRequest = async () => {
    try {
      if (remarks.trim() === "") {
        setRemarksError(true);
        return;
      }

      const request = {
        hotelId: selectedRequest.hotelId,
        bookingId: selectedRequest.bookingId,
        guestRequestId: guestRequestId,
      };

      await RejectHotel(request, remarks);
      toast.success("Request Rejected Successfully");
      func(false);
    } catch (err) {
      console.error(err);
      setErrors({ reject: err?.response?.data?.message || "Failed to respond to guest" });
    }
  };

  // Complete Hotel
  const handleCompleteHotel = async () => {
    try {
      const response = await axiosInstance.put(
        `/api/v1/hotels/${selectedRequest.hotelId}/guest-requests/${guestRequestId}/status`,
        {
          status: "Completed_Hotel",
          remarks: remarks,
        }
      );
      toast.success("Dining Request Completed");
      if (response) func(false);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Some Error Occurred");
    }
  };

  if (loading) return <PageLoader />;
  if (!data) return null;

  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
      <form
        className="popup-content bg-white p-6 rounded-lg shadow-xl text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
        onSubmit={(e) => e.preventDefault()}
      >
        {/* Header Section */}
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-800">
            Restaurant Dining
          </h2>
          <button
            onClick={() => func(false)}
            className="p-2 border border-gray-300 rounded-md hover:bg-[#F2F7FF] transition duration-150"
            type="button"
          >
            <X weight="bold" size={18} />
          </button>
        </div>

        <div>
          {/* Room Input */}
          <div className="flex gap-2 flex-col">
            <div className="flex items-center gap-2">
              <div className="font-semibold text-gray-700 flex items-center justify-between w-1/2">
                <p className="mb-1">Assigned Room</p>
                <input
                  type="text"
                  name="staff"
                  id="staff"
                  className="border-[1.5px] rounded-md p-1.5"
                  placeholder="Enter Room Number"
                  value={selectedStaff}
                  inputMode="numeric"
                  pattern="\d*"
                  disabled={disabled}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setSelectedStaff(value);
                      setErrors((prev) => ({ ...prev, selectedStaff: "" }));
                    }
                  }}
                />
              </div>
              {
                !disabled && 
              <button
                className="p-2   bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150"
                type="button"
                onClick={handleRespondToGuest}
              >
                Update
              </button>
              }

            </div>

            {errors.selectedStaff && (
              <p className="text-[#ff7378] text-[12px] flex items-center gap-1 p-0.5">
                <WarningCircle />
                {errors.selectedStaff}
              </p>
            )}

          </div>

          {
            data?.table_number &&
            <div className="flex  flex-col mt-4">
                <h2 className="font-semibold text-gray-700 flex items-center justify-between w-1/4">
                    Table Number
                    <span> 
                        {data?.table_number || ""}
                    </span>
                </h2>
                

            </div>
          }

          {/* Items Ordered Table */}
          <table className="w-full border-collapse text-left mt-2">
            <thead>
              <tr className="bg-gray-100 text-gray-700 font-semibold">
                <th className="p-2">Item</th>
                <th className="p-2">Price</th>
                <th className="p-2">Quantity</th>
              </tr>
            </thead>
            <tbody>
              {data.food_items &&
                data.food_items.map((item, index) => (
                  <tr key={index} className="border-t">
                    <td className="p-2">{item.name}</td>
                    <td className="p-2">{item.price}</td>
                    <td className="p-2">{item.quantity}</td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* Total Amount */}
          {data?.tax_amount || (data?.promotion_id && data?.discount_amount) ? (
            <div className="mt-2">
                <PromoBreakdown
                    grossAmount={data?.total_amount}
                    discountAmount={data?.discount_amount}
                    taxAmount={data?.tax_amount}
                    promotionId={data?.promotion_id}
                />
            </div>
            ) : (
            <div className="mt-2 font-semibold text-right">
              Total Amount:
              {
                data?.food_items && data.food_items.length > 0
                  ? data.food_items.reduce(
                      (total, item) => total + (item.price || 0) * (item.quantity || 0),
                      0
                  )
                : 0
              }
            </div>
          )}

          {/* Remarks Section */}
          <div className="mt-2">
            <label className="font-semibold text-gray-700">Remarks</label>
            <textarea
              rows={4}
              className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
              placeholder="Mention your comment here"
              value={remarks}
              name="remarks"
              onChange={(e) => {
                const value = e.target.value;
                setRemarks(value);
                setRemarksError(false);
              }}
            ></textarea>
            {remarksError && (
              <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                <WarningCircle size={14} />
                remarks is required when you reject the request
              </p>
            )}
          </div>

          {/* Guest Note */}
          {data.additional_comments && (
            <div>
              <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 px-6 text-sm">
                <Warning size={16} weight="bold" />{" "}
                {data.additional_comments}
              </p>
            </div>
          )}

          {/* Buttons */}
          <div className="grid grid-cols-2 gap-3 mt-2">

      

            <button
              className="p-2 w-full border-[1.5px] bg-[#73c9ff] rounded-md font-medium hover:bg-[#5fa4f7] transition duration-150 outline-none"
              type="button"
              onClick={handleCompleteHotel}
            >
              Complete Request
            </button>

            <button
              className="p-2 w-full border-[1.5px] border-red-300 text-[#ff7378] rounded-md font-medium hover:bg-red-50 transition duration-150"
              type="button"
              onClick={handleRejectRequest}
            >
              Reject Request
            </button>
          </div>

          {/* Error Messages */}
          {errors.fetch && <p className="text-red-500">{errors.fetch}</p>}
          {errors.reject && <p className="text-red-500">{errors.reject}</p>}
          {errors.respond && <p className="text-red-500">{errors.respond}</p>}
        </div>

     
      </form>
    </div>
  );
};

export default RestaurantDining;
